import { SyntheticEvent } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import useAppQueryState from '@hooks/useAppQueryState'
import useLogEvents from '@hooks/useLogEvents'

import { getAppConfig } from '@utils/getAppConfig'
import { getRedirectAccountUrl } from '@utils/getRedirectAccountUrl'

const NoHomeownerLoansBanner = () => {
    const appConfig = getAppConfig()
    const { appQueryState } = useAppQueryState()
    const logEvents = useLogEvents()

    const urlData = {
        queryObject: {
            category: 'homeowner',
            loanAmount: Number(appQueryState.loanAmount),
            loanTerm: Number(appQueryState.loanTerm),
            client: appConfig.NAME_WHITELABEL,
            loanId: null,
        },
    }

    const redirectAccountUrl = getRedirectAccountUrl(urlData)

    const onCheckEligibilityButtonPress = (
        event: SyntheticEvent<Element, Event>
    ) => {
        event.preventDefault()

        logEvents.logCheckEligibilityEvent({
            category: 'Secured',
            loanAmount: Number(appQueryState.loanAmount!),
            loanTerm: Number(appQueryState.loanTerm!),
            origin: 'unscored-secured-table',
        })

        window.location.href = redirectAccountUrl
    }

    return (
        <Stack
            space="space30"
            alignItems="center"
            data-testid="no-homeowner-loans-banner"
        >
            <Stack space="space10">
                <Heading variant="100" textAlign="center">
                    Reduce your outgoings with a homeowner loan
                </Heading>

                <Text color="dark" textAlign="center">
                    Make existing monthly payments more affordable
                </Text>
            </Stack>

            <Box>
                <LinkButton
                    text="Check my eligibility"
                    variant="primary"
                    href={redirectAccountUrl}
                    onClick={onCheckEligibilityButtonPress}
                />
            </Box>
            <Stack space="space20" alignItems="center">
                <Text variant="100" color="dark">
                    In the last 12 months, on average customers reduced
                    outgoings by over £700 a month with a homeowner
                    consolidation loan.
                </Text>

                <Text variant="60" textAlign="center" weight="bold">
                    If you consolidate your existing borrowing, you may be
                    extending the term and increasing the amount you repay in
                    total. A homeowner loan is ‘secured’ against your property.
                    This means that if you miss payments your house could be at
                    risk
                </Text>
            </Stack>
        </Stack>
    )
}

export default NoHomeownerLoansBanner
